import React, { useEffect, useState } from "react"
import { DetailsLayout, UploadFiles, LabelValue, KbMaking, CaseSummary } from "../components/bifrost"
import { ModalPopup } from "../components/modal"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Grid, Tooltip, Box, Button, IconButton, Menu, MenuList, MenuItem, Chip, Switch, Typography, Tabs, Tab } from "@material-ui/core"
import MoreVertIcon from "@material-ui/icons/MoreVert"
import {
	getCaseDetailsRequest,
	extractFileRequest,
	PiiExtractTriggerRequest,
	RevertPiiExtractRequest,
	RevertTextExtractRequest,
	changeCaseModeRequest,
	postBifrostJobRequest,
} from "../actions/bifrostActions"
import { useHistory, useParams } from "react-router-dom"
import { getStatusColor, CASE_ACTIVITY, useInterval, CASE_JOB_ACTIONS, JOB_TYPES } from "../utils"
import { useSelector, useDispatch } from "react-redux"
import TableView from "../components/common/TableView/TableView"
import { useTranslation } from "react-i18next"
import DeleteCase from "../components/bifrost/DeleteCase"
import WithDrawer from "../components/common/drawer/withDrawer"
import Notification from "../components/Notification/Notification"

const useStyles = makeStyles((theme) => ({
	actionDiv: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "flex-end",
		width: 340,
	},
	actionDivRightContent: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		"& .MuiIconButton-root": {
			paddingBottom: "8px",
		},
	},
	primaryBtn: {
		textTransform: "initial",
		fontSize: "14px",
		marginRight: "3px",
	},
	linkBtn: {
		textTransform: "initial",
	},
	gridItem: {
		paddingBottom: 12,
	},
	moreVertIconStyle: {
		fill: theme.palette.grey.P700,
	},
	deleteCasePop: {
		"& .MuiDialogTitle-root": {
			paddingTop: "32px",
			textAlign: "center",
		},
		"& .MuiDialogContent-dividers": {
			borderTop: "none",
		},
	},
	caseDetails: {
		"& .MuiDataGrid-cell": {
			padding: "0 16px",
		},
		"& .MuiChip-root": {
			borderRadius: "4px",
		},
	},
	caseMode: {
		display: "flex",
		alignItems: "center",
		margin: "-7px -10px",
		"& p": { color: theme.palette.status.maintenanceMode },
	},
	tabs: {
		color: theme.palette.primary.dark,
		"& .MuiTabs-indicator": {
			backgroundColor: theme.palette.primary.dark,
		},
		"& .MuiTab-root": {
			textTransform: "initial",
		},
	},
}))

const PageCaseDetails = () => {
	const classes = useStyles()
	const history = useHistory()
	const params = useParams()
	const theme = useTheme()
	const caseId = params.id
	const dispatch = useDispatch()
	const [t] = useTranslation("global")

	const caseDetails = useSelector((state) => state.bifrostCaseDetails.caseDetails)
	const isPageLoading = useSelector((state) => state.bifrostCaseDetails.isLoading)

	const [openUploadModal, setOpenUploadModal] = useState(false)
	const [openKbMakingModal, setOpenKbMakingModal] = useState(false)
	const [openDeleteCaseModal, setOpenDeleteCaseModal] = useState(false)
	const [actionBtnDisabled, setActionBtnDisabled] = useState(true)
	const [activeMode, setActiveMode] = useState(false)
	const [tabValue, setTabValue] = useState(0)

	useEffect(() => {
		dispatch(getCaseDetailsRequest(caseId))
	}, [])

	useEffect(() => {
		if (caseDetails && Object.keys(caseDetails).length) {
			const isCaseActive = caseDetails?.case_mode === "Active"
			setActiveMode(isCaseActive)
			let actionBtnDisabledStatus = true
			if (isPageLoading || isCaseActive) {
				actionBtnDisabledStatus = true
			} else if (!isCaseActive && caseDetails?.current_activity === CASE_ACTIVITY.IDLE) {
				actionBtnDisabledStatus = false
			}
			setActionBtnDisabled(actionBtnDisabledStatus)
		}
	}, [caseDetails, isPageLoading])

	useInterval(
		() => {
			//if (caseDetails?.current_activity !== CASE_ACTIVITY.IDLE || !!caseDetails?.current_async_activities.length) {
			if (caseDetails?.current_activity !== CASE_ACTIVITY.IDLE) {
				dispatch(getCaseDetailsRequest(caseId))
			}
		},
		15000,
		false,
		[]
	)

	const handleModeChange = (e) => {
		setActiveMode(e.target.checked)
		const case_mode = e.target.checked ? "Active" : "Maintenance"
		const payload = {
			case_id: caseId,
			case_mode,
			refreshCasePage: true,
		}
		dispatch(changeCaseModeRequest(payload))
	}

	const handleUpload = () => {
		setOpenUploadModal(true)
	}

	const handleExtract = (e) => {
		e.preventDefault()
		const payload = {
			name: caseDetails.name,
			case_id: caseId,
			refreshCasePage: true,
		}
		dispatch(extractFileRequest(payload))
	}

	const handleKbMaking = (open) => {
		setOpenKbMakingModal(open)
	}

	const closeUploadModal = (status = false) => {
		setOpenUploadModal(false)
	}

	const handlePageChange = (newPage) => {
		//To do: to implement when required
	}

	const handlePageSizeChange = (newPageSize) => {
		//To do: to implement when required
	}

	const handleViewDetailsClick = (e, jobId, jobType) => {
		e.preventDefault()
		if (JOB_TYPES.includes(jobType)) {
			history.push(`/bifrost/case/${caseId}/job-details/${jobId}`)
		} else {
			const type = jobType.toLowerCase()
			history.push(`/bifrost/case/${caseId}/${type}/${jobId}`)
		}
	}

	const [anchorEl, setAnchorEl] = React.useState(null)
	const open = Boolean(anchorEl)

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const openDeleteCasePopup = () => {
		setOpenDeleteCaseModal(true)
		handleClose()
	}

	const handlePiiExtract = (type) => {
		const payload = {
			// name: caseDetails.name,
			case_id: caseId,
			refreshCasePage: true,
			job_type: type || "",
			filter: {},
		}
		dispatch(PiiExtractTriggerRequest(payload))
	}

	const handleRevertPiiExtract = (type) => {
		const payload = {
			case_id: caseId,
			refreshCasePage: true,
			job_type: type || "",
			filter: {},
		}
		dispatch(RevertPiiExtractRequest(payload))
	}

	const handleRevertTextExtract = () => {
		const payload = {
			case_id: caseId,
			refreshCasePage: true,
		}
		dispatch(RevertTextExtractRequest(payload))
	}

	const handleTabChange = (event, newValue) => {
		setTabValue(newValue)
	}

	const handleBifrostJob = (type) => {
		const payload = {
			case_id: caseId,
			job_type: type || "",
			filter: {},
			refreshCasePage: true,
		}
		dispatch(postBifrostJobRequest(payload))
	}

	const getActionItems = () => {
		return (
			<div className={classes.actionDiv}>
				<section>
					<Button
						variant="contained"
						color="primary"
						className={classes.primaryBtn}
						onClick={(e) => {
							handleUpload(e)
						}}
						disabled={actionBtnDisabled}
					>
						{t("bifrost.buttonTexts.upload")}
					</Button>
					<Button
						variant="contained"
						color="primary"
						className={classes.primaryBtn}
						onClick={(e) => {
							handleExtract(e)
						}}
						disabled={actionBtnDisabled}
					>
						{t("bifrost.buttonTexts.extract")}
					</Button>
					<Button
						variant="contained"
						color="primary"
						className={classes.primaryBtn}
						onClick={(e) => {
							handleKbMaking(e)
						}}
						disabled={actionBtnDisabled}
					>
						{t("bifrost.buttonTexts.kbMaking")}
					</Button>
				</section>
				<section className={classes.actionDivRightContent}>
					<Button
						className={classes.linkBtn}
						onClick={() => {
							history.push("/bifrost")
						}}
						color="primary"
					>
						{t("bifrost.buttonTexts.back")}
					</Button>
					<nav>
						<IconButton aria-label="more" aria-controls="long-menu" aria-haspopup="true" onClick={handleClick}>
							<MoreVertIcon className={classes.moreVertIconStyle} />
						</IconButton>
						<Menu
							id="long-menu"
							anchorEl={anchorEl}
							keepMounted={false}
							open={open}
							onClose={handleClose}
							PaperProps={{
								style: {
									maxHeight: 48 * 4.5,
									transform: "translateY(5px)",
								},
							}}
							getContentAnchorEl={null}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "center",
							}}
							transformOrigin={{
								vertical: "top",
								horizontal: "right",
							}}
						>
							<MenuList>
								<MenuItem
									disabled={actionBtnDisabled}
									onClick={() => handlePiiExtract(CASE_JOB_ACTIONS[0]?.pii_extract?.type)}
								>
									{t("bifrost.buttonTexts.extractNames")}
								</MenuItem>
								<MenuItem
									disabled={actionBtnDisabled}
									onClick={() => handleRevertPiiExtract(CASE_JOB_ACTIONS[0]?.revert_pii_extract?.type)}
								>
									{t("bifrost.buttonTexts.revertPiiExtract")}
								</MenuItem>
								<MenuItem
									disabled={actionBtnDisabled}
									onClick={() => handleBifrostJob(CASE_JOB_ACTIONS[0]?.summary_extract?.type)}
								>
									{t("bifrost.buttonTexts.genSummary")}
								</MenuItem>
								<MenuItem
									disabled={actionBtnDisabled}
									onClick={() => handleBifrostJob(CASE_JOB_ACTIONS[0]?.revert_summary_extract?.type)}
								>
									{t("bifrost.buttonTexts.revertGenSummary")}
								</MenuItem>
								<MenuItem
									disabled={actionBtnDisabled}
									onClick={() => handleBifrostJob(CASE_JOB_ACTIONS[0]?.pdf_convert?.type)}
								>
									{t("bifrost.buttonTexts.pdfConvert")}
								</MenuItem>
								<MenuItem
									disabled={actionBtnDisabled}
									onClick={() => handleBifrostJob(CASE_JOB_ACTIONS[0]?.revert_pdf_convert?.type)}
								>
									{t("bifrost.buttonTexts.revertPdfConvert")}
								</MenuItem>
								<MenuItem disabled={actionBtnDisabled} onClick={handleRevertTextExtract}>
									{t("bifrost.buttonTexts.revertTextExtract")}
								</MenuItem>
								<MenuItem
									disabled={actionBtnDisabled && caseDetails?.current_activity !== "soft-delete"}
									onClick={openDeleteCasePopup}
								>
									{t("bifrost.buttonTexts.deleteCase")}
								</MenuItem>
							</MenuList>
						</Menu>
					</nav>
				</section>
			</div>
		)
	}

	const getRows = () => {
		return caseDetails?.job_details
			? caseDetails.job_details.map((job) => ({
					id: job.job_id,
					name: job.name,
					job_type: job.job_type,
					date_time: new Date(job?.create_time).toLocaleString(),
					file_count: job?.execution_status?.total || 0,
					file_size: "-",
					runtime_status: job.status,
					completed_count: job?.execution_status?.summary?.Done || 0,
					failed_count: job?.execution_status?.summary?.Failed || 0,
			  }))
			: []
	}

	const getToolTipSection = (value) => {
		return (
			<Tooltip title={value} placement="top">
				<Box style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{value}</Box>
			</Tooltip>
		)
	}
	const getColumns = () => {
		return [
			{
				field: "id",
				headerName: t("bifrost.table_headers.jobId"),
				sortable: false,
				resizable: true,
				flex: 0.3,
				width: 250,
				renderCell: (params) => getToolTipSection(params?.row?.id),
			},
			{
				field: "name",
				headerName: t("bifrost.table_headers.jobName"),
				sortable: false,
				resizable: true,
				flex: 0.2,
				width: 180,
				renderCell: (params) => getToolTipSection(params?.row?.name),
			},
			{
				field: "job_type",
				headerName: t("bifrost.table_headers.process"),
				sortable: false,
				width: 160,
				renderCell: (params) => getToolTipSection(params?.row?.job_type),
			},
			{
				field: "date_time",
				headerName: t("bifrost.table_headers.startDate"),
				sortable: false,
				flex: 0.3,
				width: 200,
				renderCell: (params) => getToolTipSection(params?.row?.date_time),
			},
			{
				field: "file_count",
				headerName: t("bifrost.table_headers.totalFileCount"),
				sortable: false,
				width: 150,
			},
			{
				field: "runtime_status",
				headerName: t("bifrost.table_headers.runtimeStatus"),
				sortable: false,
				width: 180,
				flex: 0.2,
				renderCell: (params) => (
					<Chip
						label={params?.row?.runtime_status}
						size="small"
						style={{
							textTransform: "capitalize",
							color: getStatusColor(params?.row?.runtime_status, theme).color,
							backgroundColor: getStatusColor(params?.row?.runtime_status, theme).background,
						}}
					/>
				),
			},
			{
				field: "completed_count",
				headerName: t("bifrost.table_headers.completedFiles"),
				sortable: false,
				width: 160,
			},
			{
				field: "failed_count",
				headerName: t("bifrost.table_headers.failedFiles"),
				sortable: false,
				width: 110,
			},
			{
				field: "details",
				headerName: t("bifrost.table_headers.details"),
				width: 130,
				sortable: false,
				renderHeader: () => <Box style={{ paddingLeft: "8px", fontWeight: "500" }}>{t("bifrost.table_headers.details")}</Box>,
				renderCell: (params) => (
					<Button
						onClick={(e) => handleViewDetailsClick(e, params?.row?.id, params?.row?.job_type)}
						color="primary"
						className={classes.primaryBtn}
					>
						{t("bifrost.buttonTexts.viewDetails")}
					</Button>
				),
			},
		]
	}

	const getListView = () => {
		return (
			<TableView
				columns={getColumns()}
				rows={getRows()}
				isLoading={isPageLoading}
				pageInfo={{
					page: 1,
					pageSize: 20,
					rowsPerPageOptions: [5, 10, 20, 50],
					totalRowCount: caseDetails?.job_details?.length,
					paginationMode: "server",
					handlePageChange: () => {},
					handlePageSizeChange: () => {},
				}}
				sortInfo={{
					sortingMode: "server",
					sortModel: [],
					onSortModelChange: () => {},
				}}
				checkboxSelection={false}
				footerInfo={{
					hideFooter: false,
					hideSelectionCount: true,
					hidePagination: true,
				}}
				topBarInfo={{
					show: true,
					rightSection: "",
				}}
				totalCountText={`${t("tableColumns.totalJobs")}: ${caseDetails?.job_details?.length || 0}`}
				showDownloadButton={false}
				showColumnsButton={false}
			/>
		)
	}

	const getTabs = () => {
		return (
			<Tabs value={tabValue} className={classes.tabs} onChange={handleTabChange} aria-label="tabs view">
				<Tab label={t("bifrost.buttonTexts.allJobs")} />
				<Tab label={t("bifrost.buttonTexts.caseSummary")} />
			</Tabs>
		)
	}

	const getTabsView = () => {
		if (tabValue === 0) return getListView()
		else if (tabValue === 1) return <CaseSummary />
	}

	return (
		<div data-cy="case-details" className={classes.caseDetails}>
			<DetailsLayout
				loading={isPageLoading}
				titleProps={{
					title: t("bifrost.titles.caseDetails"),
					name: caseDetails?.name,
					status: caseDetails?.case_mode === "Active" ? caseDetails?.case_mode : null,
				}}
				actionItems={getActionItems()}
				listView={getTabsView()}
				showActionsView={true}
				leftActions={getTabs()}
			>
				<>
					<Grid item xs={9} className={classes.gridItem}>
						<LabelValue
							label={t("bifrost.metadataKeys.caseDescription")}
							value={caseDetails.description || "—"}
							loading={isPageLoading}
						/>
					</Grid>
					<Grid item xs={3}>
						<Grid container item direction="row" xs={12}>
							<Grid item xs={7}>
								<LabelValue
									label={t("bifrost.metadataKeys.caseCreatedDate")}
									value={!!caseDetails.create_time ? new Date(caseDetails?.create_time).toLocaleString() : "—"}
									loading={isPageLoading}
								/>
							</Grid>
							<Grid item xs={5}>
								<LabelValue
									label={t("bifrost.metadataKeys.caseStatus")}
									value={
										<div className={classes.caseMode}>
											<Switch
												checked={activeMode}
												onChange={handleModeChange}
												name="caseStatus"
												inputProps={{ "aria-label": "case status" }}
											/>
											<Typography variant="body2" component="p">
												{activeMode ? t("bifrost.metadataKeys.active") : t("bifrost.metadataKeys.maintenance")}
											</Typography>
										</div>
									}
									loading={isPageLoading}
								/>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={9} className={classes.gridItem}></Grid>
					<Grid item xs={3} className={classes.gridItem}>
						<LabelValue
							label={t("bifrost.metadataKeys.caseCreatedBy")}
							value={caseDetails.created_by_username}
							loading={isPageLoading}
						/>
					</Grid>
				</>
				<ModalPopup title={t("bifrost.titles.uploadDocs")} open={openUploadModal} setOpen={setOpenUploadModal} outSideClickClose>
					<UploadFiles callback={closeUploadModal} data={caseDetails} refreshCasePage={true} />
				</ModalPopup>
				<ModalPopup title={t("bifrost.titles.createKb")} open={openKbMakingModal} setOpen={setOpenKbMakingModal} outSideClickClose>
					<KbMaking callback={handleKbMaking} data={caseDetails} refreshCasePage={true} />
				</ModalPopup>
				<ModalPopup
					className={classes.deleteCasePop}
					title={t("bifrost.deleteCase.title")}
					open={openDeleteCaseModal}
					setOpen={setOpenDeleteCaseModal}
					outSideClickClose
				>
					<DeleteCase callback={setOpenDeleteCaseModal} data={caseDetails} />
				</ModalPopup>
				<Notification />
			</DetailsLayout>
		</div>
	)
}

export default WithDrawer(PageCaseDetails)
